export type OverviewPage = 'table' | 'map' | 'fullscreen'

export function isValidPage(page: string | null): page is OverviewPage {
  return ['map', 'table', 'fullscreen'].includes(page ?? '')
}

export type PageProps = {
  page: OverviewPage
  setPage: (page: OverviewPage) => void
}
